__turbopack_context__.v({
  "optionChainTabs": "EqYl3G_optionChainTabs",
  "optionTab": "EqYl3G_optionTab",
});
